import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { FieldSlider } from '@snack-uikit/fields';
import { parseKeyToDataTest } from '../../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function SliderControlUi(_ref) {
  var _ref2, _relatedUiProps$visib;
  var decoratorProps = _ref.decoratorProps,
    uiProps = _ref.uiProps,
    onChange = _ref.onChange,
    itemsProp = _ref.items,
    watchedValues = _ref.watchedValues,
    relateFn = _ref.relateFn,
    accessorKey = _ref.accessorKey,
    value = _ref.value;
  var _useMemo = useMemo(function () {
      var _relateFn;
      return (_relateFn = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn !== void 0 ? _relateFn : {};
    }, [relateFn, watchedValues]),
    relatedItems = _useMemo.items,
    relatedDecoratorProps = _useMemo.decoratorProps,
    relatedUiProps = _useMemo.uiProps;
  var items = useMemo(function () {
    return relatedItems !== null && relatedItems !== void 0 ? relatedItems : itemsProp;
  }, [itemsProp, relatedItems]);
  var dataTestAttribute = parseKeyToDataTest('slider', accessorKey);
  var _useMemo2 = useMemo(function () {
      var marks = items.sort(function (a, b) {
        return a - b;
      }).reduce(function (res, item, idx) {
        res[idx + 1] = item;
        return res;
      }, {});
      return {
        marks: marks
      };
    }, [items]),
    marks = _useMemo2.marks;
  var textInputValueFormatter = function textInputValueFormatter(value) {
    return String(marks[value]);
  };
  var visible = (_ref2 = (_relatedUiProps$visib = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.visible) !== null && _relatedUiProps$visib !== void 0 ? _relatedUiProps$visib : uiProps === null || uiProps === void 0 ? void 0 : uiProps.visible) !== null && _ref2 !== void 0 ? _ref2 : true;
  if (!visible) {
    return null;
  }
  var currentValue = value ? items.findIndex(function (item) {
    return String(item) === value;
  }) + 1 : 1;
  return /*#__PURE__*/_jsx(FieldSlider, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    range: false,
    size: "m",
    value: currentValue,
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange.toString();
      };
      return onChange;
    }(function (newValue) {
      var valueByKey = String(marks[newValue]);
      onChange === null || onChange === void 0 ? void 0 : onChange(valueByKey);
    }),
    marks: marks,
    min: 1,
    max: items.length,
    step: null,
    textInputFormatter: textInputValueFormatter,
    "data-test-id": dataTestAttribute
  }, uiProps), relatedUiProps), decoratorProps), relatedDecoratorProps));
}